import React from 'react';

import { useCompanySetup } from '../MasterDataProvider';

/**
 * The renderer and the summary writer live in different parts of the tree but have to agree: if one
 * decides link-based while the other decides content-based, the QR encodes a reference to a summary
 * nobody stored, or a stored summary nobody reads.
 */
export const useIsLinkBasedQr = () => {
  const companySetup = useCompanySetup();

  return React.useMemo(() => {
    if (!companySetup?.data?.qrMethod) {
      return true;
    }

    return companySetup?.data?.qrMethod === 'linkBased';
  }, [companySetup?.data?.qrMethod]);
};
